(ns story-builder.util.url
  (:require
   [camel-snake-kebab.core :as csk]
   [camel-snake-kebab.extras :as cske]
   [cljs-time.core :as t]
   [cljs-time.format :as tf]
   [cljs.reader]
   [clojure.string :as str]
   [clojure.walk :as walk]
   [goog.Uri :as gurl]
   [story-builder.util.date-time :as util.date-time])
  (:import [goog.Uri QueryData]))

(def url-regex #"(?i)^(?:https?://|(?:mailto:\S+@|tel:\+?)|//)(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?|\d{6,}$|[0-9]+)(?::\d{2,5})?(?:[/?#]\S*)?$")

(def phone-number-regex #"^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$")

(def email-regex #"^\S+@\S+\.\S+$")

(defn parse-qs-val [v]
  (cond
    (and (string? v)
         (re-matches #"\{[\s\S]+\}" v))
    (try
      (cljs.reader/read-string v)
      (catch :default _
        (try
          (-> (js/JSON.parse v)
              (js->clj :keywordize-keys true))
          (catch :default _
            v))))
    (and (string? v)
         (re-matches #"\d{4}-\d{2}-\d{2}" v))
    (tf/parse (tf/formatters :date) v)
    (and (string? v)
         (re-matches #"[0-9]+" v))
    (js/parseInt v)
    (and (string? v)
         (= v "true"))
    true
    (and (string? v)
         (= v "false"))
    false
    :else
    (js/decodeURIComponent v)))

(defn qs->clj []
  (let [x (QueryData. (str/replace js/window.location.search #"\?" ""))]
    (->> (into {}
               (for [k    (set (.getKeys x))
                     :let [vals (js->clj (.getValues x k))
                           vals (mapv parse-qs-val vals)]]
                 [k (if (= 1 (count vals)) (last vals) vals)]))
         (walk/keywordize-keys)
         (cske/transform-keys csk/->kebab-case))))

(defn clj->qs [data]
  (->> (reduce (fn [acc [k v]]
                 (cond
                   (= (type v) js/Date)
                   (assoc acc k (tf/unparse (tf/formatters :date) (util.date-time/date-time v)))
                   (t/date? v)
                   (assoc acc k (tf/unparse (tf/formatters :date) v))
                   (map? v)
                   (assoc acc k (pr-str v))
                   :else
                   (assoc acc k v)))
               {}
               data)
       (clj->js)
       (.createFromMap QueryData)
       (.toString)))

(defn valid-url? [url allow-blank?]
  (let [blank?   (str/blank? url)
        matches? (and (not blank?)
                      (re-matches url-regex url))]
    (or (and allow-blank? blank?)
        matches?)))

(defn parse-url [url]
  (let [parsed (gurl/parse url)
        domain (.getDomain parsed)
        path   (.getPath parsed)]
    {:host domain :path path}))
